







import Vue from "vue";
import { SpinnerPlugin } from "bootstrap-vue";

Vue.use(SpinnerPlugin);

export default Vue.extend({
  name: "AppPageSpinner"
});
